import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { iAdminService } from 'src/app/core/services/iAdmin.service';
import { CreateClassementAdmin } from 'src/app/shared/models/admin/classement';

@Component({
  selector: 'app-create-classement',
  templateUrl: './create-classement.component.html',
  styleUrls: ['./create-classement.component.scss'],
})
export class CreateClassementComponent implements OnInit {
  form: FormGroup = new FormGroup({
    actif: new FormControl(true, [Validators.required]),
    description: new FormControl('', [Validators.required]),
    code: new FormControl('', [Validators.required]),
  });
  constructor(
        public dialogRef: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public iAdminService: iAdminService,
        public toast: ToastrService,
  ) {}

  ngOnInit(): void {
    return;
  }

  createClassement() {
    const data: CreateClassementAdmin = {
      actif: this.form.get('actif').value,
      code: this.form.get('code').value,
      description: this.form.get('description').value,
      parentId: null,
    };
    this.iAdminService.createClassement(data).subscribe({
      next: (code) => {
        this.toast.success('Classement créé avec succès');
        this.onClose(code);
      },
      error: () => {
        this.toast.error('Erreur lors de la création du classement');
        return false;
      },
    });
  }

  onClose(code?) {
    console.log('onClose');
    this.dialogRef.close(code);
  }

}
